import { forwardRef } from '@heroui/system';
import { RadioGroupProvider, useRadioGroup, RadioGroupProps } from '@heroui/react';
import { noop } from 'lodash-es';

const RadioGroup = forwardRef<'div', RadioGroupProps>((props, ref) => {
  const {
    Component,
    children,
    label,
    context,
    description,
    isInvalid,
    errorMessage,
    getGroupProps,
    getLabelProps,
    getWrapperProps,
    getDescriptionProps,
    getErrorMessageProps,
  } = useRadioGroup({ ...props, ref });

  return (
    <Component {...getGroupProps()} onKeyDown={noop}>
      {label && <span {...getLabelProps()}>{label}</span>}
      <div {...getWrapperProps()}>
        <RadioGroupProvider value={context}>{children}</RadioGroupProvider>
      </div>
      {isInvalid && errorMessage && <div {...getErrorMessageProps()}>{errorMessage}</div>}
      {!isInvalid && description && <div {...getDescriptionProps()}>{description}</div>}
    </Component>
  );
});

RadioGroup.displayName = 'HeroUI.RadioGroup';

export default RadioGroup;
